import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchFeaturedCategoryAPI() {
    const response = await fetch(`${baseURL}/api/version3/featured-categories`);
    if(!response.ok) throw new error("Failed to retch featured category data");
    return response.json()
}